import clsx from "clsx";
import { useSelectedFile } from "../../hooks/useSelectedFile";
import { DraftMenu } from "./DraftMenu";
import { CheckIcon } from "@heroicons/react/24/outline";
import { rightDrawerOpenAtom } from "@/features/Navigation/state";
import { useSetAtom } from "jotai";
import { showCommitPanelAtom } from "../../Labeling.state";
import { useDraft } from "../../hooks/useDraft";
import { FileMeta } from "./FileMeta";
import { FloatingMenu, FloatingMenuCommand } from "@/ui/organisms/FloatingMenu";

export function FileHeading() {
    const { isLoading, selectedFile } = useSelectedFile();
    const setRightDrawerOpen = useSetAtom(rightDrawerOpenAtom);
    const setShowCommitPanel = useSetAtom(showCommitPanelAtom);
    const { isReadonly, draft } = useDraft();

    if (isLoading)
        return (
            <div
                className={clsx(
                    "bg-selected h-[120px] w-full",
                    "animate-pulse rounded",
                )}
            />
        );

    if (!selectedFile) return null;

    return (
        <div className="flex flex-col gap-5">
            <div
                className={clsx(
                    "w-full",
                    "flex items-start justify-between gap-10",
                )}
            >
                <div className="flex w-full flex-col gap-1">
                    <h1 className="pageheading break-all">
                        {selectedFile.name}
                    </h1>

                    <div className="mb-1">
                        <FileMeta file={selectedFile} />
                    </div>
                </div>

                {draft && !isReadonly && (
                    <FloatingMenu>
                        <FloatingMenuCommand
                            icon={<CheckIcon className="cursor-pointer" />}
                            command={{
                                label: "Commit draft (⌘S)",
                                shortcut: {
                                    key: "s",
                                    mac: "⌘S",
                                    windows: "Ctrl+S",
                                },
                                onClick: () => {
                                    setRightDrawerOpen(true);
                                    setShowCommitPanel(true);
                                },
                            }}
                        />
                    </FloatingMenu>
                )}
            </div>

            <DraftMenu />
        </div>
    );
}
